import React from "react";
import { Cookies } from "../../index.js";
import History from "../../nhatkyorders.jsx";
import HistoryEmpty from "./history_new.jsx";

const ScamsCheckHistory = () => {
  const apikey = Cookies.get("apikey");

  return (
    <>
    <div className="mb-3 mt-3 mx-auto max-w-4xl">
      <div className="bg-green-100/60 border border-green-200 rounded-lg p-4 flex items-start gap-3 shadow-sm">
        {/* Icon chữ i nhỏ nhẹ */}
        <div className="text-emerald-500 mt-1">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
        </div>
        
        {/* Nội dung Tiếng Anh: Thuận văn - An toàn - Kỹ thuật */}
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-slate-700 mb-1">
            System Audit Log
          </h4>
          <p className="text-sm text-slate-600 leading-relaxed">
            The list below displays the history of processed system requests. 
            Data is retained for <strong>operational transparency</strong> and to assist users with information retrieval. 
            All records are encrypted to ensure privacy.
          </p>
        </div>
      </div>
    </div>
      {apikey ? <History /> : <HistoryEmpty />}
    </>
  );
};

export default ScamsCheckHistory;
